export function getCurrentUrl(pathname: string) {
  return pathname.split(/[?#]/)[0]
}

export function checkIsActive(pathname: string, url: string) {
  const current = getCurrentUrl(pathname)
  if (!current || !url) {
    return false
  }

  if (current === url) {
    return true
  }

  const projectPagePattern = /^\/projects\/[^\/]+$/
  if (projectPagePattern.test(url)) {
    return false
  }

  if (current.startsWith(url + '/')) {
    return true
  }

  return false
}

export function checkIsEqueal(pathname: string, url: string) {
  return pathname === url
}
